export default "/public/dist/img/immagineNotizia19-03.png";